<template>
  <div class="overlay" v-if="show" @click.self="close()">
    <div class="overlay__wrapper">
      <div class="overlay__header">
        <div class="overlay__title">
          <slot name="title" />
        </div>
        <button class="overlay__close button--no" @click="close()"><icon name="close"/></button>
      </div>
      <div class="overlay__content">
        <slot name="default" />
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.overlay{
    position:fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: $nc-catalog__overlay;
    &__wrapper{
        width: 300px;
        margin-left: auto;
        height: 100%;
        background: $nc-catalog__overlay-bg;
        color: $nc-catalog__overlay-color;
    }
    &__header{
        padding: $content;
        display: flex;
        justify-content: space-between;
        height: 53px;
    }
    &__title{
        font-size: $h1;
        font-weight: bold;
    }
    &__content{
        background: $nc-catalog__overlay-content-bg;
        overflow:auto;
        height: calc(100vh - 53px)
    }
}
</style>
<script>
export default {
	name: 'nc-overlay',
	model:{
		prop: 'show',
		event: 'show'
	},
	props:{
		show: Boolean
	},
	methods: {
		close(){
			this.$emit('show', false)
		}
	},
	data () {
		return {
		}
	}
}
</script>
